/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useStyles } from './styles';
import { IDP_ROLE_TOOLTIP, CUSTOMER_IDP, LIAM } from './constants';
import { IRole, IRenderChips } from '../../models/Roles/RolesContracts';
import { LuiChip } from '@jda/lui-common-component-library-mui5';

export const getLabel = (option: { name?: string }) => option.name || 'lui-chip';

export const RenderChips = ({ selectedRole, disabled, deleteRole }: IRenderChips) => {
  const { classes } = useStyles();
  const sortedRole = [...selectedRole.filter((role: any) => (role.associatedFrom === LIAM || role.associatedFrom === undefined)), ...selectedRole.filter((role: any) => role.associatedFrom === CUSTOMER_IDP)]
  return (
    <React.Fragment>
      {sortedRole.map((option: IRole, index: number) => {
        const label: string = getLabel(option);
        return option.associatedFrom === CUSTOMER_IDP ? (
          <Tooltip title={IDP_ROLE_TOOLTIP} key={index}>
            <LuiChip data-testid="role-chip" key={index} disabled={disabled} label={label} />
          </Tooltip>
        ) : (
          <Box className={classes.chip}>
          <LuiChip
            data-testid="role-chip"
            key={index}
            disabled={disabled}
            label={label}
            deleteIcon={<ClearIcon />}
            onDelete={() => {
              deleteRole && deleteRole(option);
            }}
          />
          </Box>
        );
      })}
    </React.Fragment>
  );
};
